import joinClasses from "../../../../helpers/joinClasses";

export default function FilterItem({children, title, className = ""}){
    return (
        <div className={joinClasses(className,`flex flex-col w-full items-center gap-[15px]`)}>
                    <p className="font-medium">{title}</p>
                    {children}
        </div>
    )
}